<template>
  <div>
    <title>微门店数据报表</title>
    <section class="mainPart">
       <!--S 公用头部切换-->
      <!--E 公用头部切换-->
      <!--S 检索-->
      <el-form :model="searchForm" inline class="">
        <el-form-item label="券卡编码" class="codeSerIpt">
          <el-input clearable v-model="searchForm.code" placeholder="请输入券卡编码"></el-input>
        </el-form-item>
        <el-form-item label="序列号">
          <el-input clearable v-model="searchForm.serial" placeholder="请输入序列号"></el-input>
        </el-form-item>
        <el-form-item label="券卡状态" class="formTimeSlot">
          <el-select v-model="searchForm.state" placeholder="请选择" clearable>
            <el-option label="未激活" value="0"></el-option>
            <el-option label="未提货" value="1"></el-option>
            <el-option label="部分提货" value="2"></el-option>
            <el-option label="已提货" value="3"></el-option>
            <el-option label="已回收" value="5"></el-option>
            <el-option label="重新出库" value="7"></el-option>
            <el-option label="已暂停使用" value="4"></el-option>
            <el-option label="已作废" value="6"></el-option>
            <el-option label="回收折现" value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="激活微门店">
          <el-select v-model="searchForm.actflowcode" placeholder="请选择" clearable filterable>
            <el-option v-for="(intm,index) in FlowList"  :key="index" :label="intm.flowname" :value="intm.flowcode"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="激活店员">
          <el-select v-model="searchForm.corderuname" placeholder="请选择" clearable>
            <el-option label="店员A" :value="0"></el-option>
            <el-option label="店员B" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="激活时间">
          <el-date-picker 
            v-model="searchForm.actdate" 
            type="daterange"        
            format="yyyy - MM - dd" 
            value-format="yyyy-MM-dd"  
            range-separater="至" 
            start-placeholder="开始日期" 
            end-placeholder="结束日期"
            :picker-options="pickOptions"
            :unlink-panels = "true">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="核销微门店">
          <el-select v-model="searchForm.wfflowcode" placeholder="请选择" clearable filterable>
           <el-option v-for="(intm,index) in FlowList"  :key="index" :label="intm.flowname" :value="intm.flowcode"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="核销店员">
          <el-select v-model="searchForm.corderuname" placeholder="请选择" clearable>
            <el-option label="店员A" :value="0"></el-option>
            <el-option label="店员B" :value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="核销时间">
          <el-date-picker 
            v-model="searchForm.wfdate" 
            type="daterange"       
            format="yyyy - MM - dd" 
            value-format="yyyy-MM-dd"   
            range-separater="至" 
            start-placeholder="开始日期" 
            end-placeholder="结束日期"
            :picker-options="pickOptions"
            :unlink-panels = "true">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getWriteoffRecords">查询</el-button>
          <el-button type="primary" plain v-show="payRecordList.length>0" @click="getWriteoffRecordsExporturl">导出</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->
      <!--S 列表-->
      <el-table ref="gsTable" class="gsTable comTable borderTable" border :data="payRecordList" v-loading="isLoad" :maxHeight="tableHeight">
        <el-table-column label="序号" type="index" fixed width="60"></el-table-column>
        <el-table-column label="激活微门店" prop="actflowcode" sortable min-width="250">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.actflowname ||''">{{scope.row.actflowname||'--'}}</p>
            <small v-if="scope.row.actdate&&scope.row.actdate!=null">激活时间：{{scope.row.actdate&&scope.row.actdate!=null?dateTime(scope.row.actdate,1):'--'}}</small>
          </template>
        </el-table-column>
        <el-table-column label="券卡编码" prop="state" sortable min-width="310">
          <template slot-scope="scope">
            <p>{{scope.row.code||'--'}} <em v-show="scope.row.serial&&scope.row.serial!=null">【{{scope.row.serial}}】</em></p>
            <span class="orangeColor" v-if="scope.row.state == 0 || scope.row.state == 1">{{scope.row.state | cardStateFilter}}</span>
            <span class="greenColor" v-else-if="scope.row.state == 2 || scope.row.state == 5 || scope.row.state == 7">{{scope.row.state | cardStateFilter}}</span>
            <span class="redColor" v-else-if="scope.row.state == 4 || scope.row.state == 6">{{scope.row.state | cardStateFilter}}</span>
            <span class="blueColor" v-else-if="scope.row.state == 3">{{scope.row.state | cardStateFilter}}</span>
            <span class="greyColor" v-else>{{scope.row.state | cardStateFilter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="默认商品" prop="defaultgoodscode" sortable min-width="220">
          <template slot-scope="scope">
            <p class="txtLineTwo" :title="scope.row.defaultgoodsname || ''">{{scope.row.defaultgoodsname ||'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="核销方" prop="wfflowcode" sortable min-width="250">
          <template slot-scope="scope">
            <p class="textFl" :title="scope.row.wfflowname||''">{{scope.row.wfflowname||'--'}}</p>
            <small>核销时间：{{scope.row.wfdate&&scope.row.wfdate!=null?dateTime(scope.row.wfdate,1):'--'}}</small>
          </template>
        </el-table-column>
        <el-table-column label="订单号" prop="orderno" sortable min-width="230">
          <template slot-scope="scope">
            <p :title="scope.row.orderno||''">{{scope.row.orderno ||'--'}}</p>
          </template>
        </el-table-column>
        <el-table-column label="订单内容" prop="ordercontent" sortable min-width="220">
          <template slot-scope="scope">
            <p class="txtLineTwo" :title="scope.row.ordercontent ||''">{{scope.row.ordercontent ||'--'}}</p>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="noData">
            <span>暂无数据</span>
          </div>
        </template>
      </el-table>
      <!--E 列表-->
       <!-- S 分页 -->
      <Page :pageTotal="pagebean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
    </section>


  </div>
</template>
<script>
import api from '@/apis/api.js';
import { Message, MessageBox } from "element-ui";
export default {
  name:'WShopStatistic',
  data () {
    return {
      isLoad:false,
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebean: {
          totalnum: 0,
      }, // 获取到的列表分页信息
      currentTit:3, //当前选中菜单
      highShow: false, //是否展示高级筛选
      groupShow: false,//归类统计弹窗
      searchForm:{
        code:'',
        state:'',
        serial:'',
        defaultgoodsname:'', 
        actflowcode:'',
        actdate:'',
        wfflowcode:'',
        wfdate:'',
      },
      pickOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      payRecordList:[],
      FlowList:[],
      tableHeight: window.innerHeight*.8, //表格动态高度
      
    }
  },
  filters: {
    //券卡状态过滤
    cardStateFilter(value){
      if (value == 0) {
          return '未激活';
      } else if (value == 1) {
          return '未提货';
      } else if (value == 2) {
          return '部分提货';
      } else if (value == 3) {
          return '已提货';
      } else if (value == 4) {
          return '暂停提货';
      } else if (value == 5) {
          return '已回收';
      } else if (value == 6) {
          return '已作废';
      } else if (value == 7) {
          return '重新出库';
      } else if (value == 8) {
          return '回收折现';
      }
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
  },
  // ============================================== 监听 ==============================================
 watch: {
    
  },
  // ============================================== 方法 ==============================================
  methods: {
    // 导出表格
    getWriteoffRecordsExporturl() {
      let params = {
        code:this.searchForm.code,
        serial:this.searchForm.serial,
        actflowcode:this.searchForm.actflowcode,
        actsdate:this.searchForm.actdate? this.searchForm.actdate[0]+' 00:00:00' : '',
        actedate:this.searchForm.actdate? this.searchForm.actdate[1]+' 23:59:59' : '',
        state:this.searchForm.state==''?null:Number(this.searchForm.state),
        wfsdate:this.searchForm.wfdate? this.searchForm.wfdate[0]+' 00:00:00' : '',
        wfedate:this.searchForm.wfdate? this.searchForm.wfdate[1]+' 23:59:59' : '',
        wfflowcode:this.searchForm.wfflowcode
      }
      api.GET_CARDACTANDWRITEOFFSTATISTICSEXPORTURL(params).then((res) => {
        if(res.data.status == '200'&&res.data.data!=null){
          this.$message.success('导出成功！');
          window.location.href = res.data.data
        }else{
          this.$message.error(res.data.message);
        }
      })
      
    },
        // 接收分页信息
    updatePage(size,num) {
        this.pageSize = size;
        this.currentPage = num;
        this.getWriteoffRecords();
    },
     // 获取列表信息
    getWriteoffRecords(){
      let params = {
        code:this.searchForm.code,
        serial:this.searchForm.serial,
        actflowcode:this.searchForm.actflowcode,
        actsdate:this.searchForm.actdate? this.searchForm.actdate[0]+' 00:00:00' : '',
        actedate:this.searchForm.actdate? this.searchForm.actdate[1]+' 23:59:59' : '',
        state:this.searchForm.state==''?null:Number(this.searchForm.state),
        wfsdate:this.searchForm.wfdate? this.searchForm.wfdate[0]+' 00:00:00' : '',
        wfedate:this.searchForm.wfdate? this.searchForm.wfdate[1]+' 23:59:59' : '',
        wfflowcode:this.searchForm.wfflowcode,
        pageparam:{
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        } 
      }
      this.isLoad = true;
      api.GET_CARDACTANDWRITEOFFSTATISTICS(params).then((res) => {
        this.toTableTop('gsTable');
        if(res.data.status == '200'){
          this.isLoad = false;
          this.payRecordList = res.data.data;
          if(res.data.pagebean){
            this.pagebean = res.data.pagebean
          }
        }
      })
    },
    getFlowList(){
       api.GET_FLOWLIST({objtype: 4}).then((res) => {
        if(res.data.status == '200'){
          this.FlowList = res.data.data;
        }
      })
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    this.getWriteoffRecords();
    this.getFlowList();
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200)

  },
  computed: {},
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  }
}
</script>
<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.searchForm{padding-top: 64px;}
</style>



// WEBPACK FOOTER //
// src/views/ManageFolder/PlatformUser/WShopStatistic.vue